/* tslint:disable */
require('./UserRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_24f5a6ff',
  user: 'user_24f5a6ff',
  relative: 'relative_24f5a6ff',
  main: 'main_24f5a6ff',
  fabricIcon: 'fabricIcon_24f5a6ff',
  actions: 'actions_24f5a6ff',
  chat: 'chat_24f5a6ff',
  sections: 'sections_24f5a6ff',
  section: 'section_24f5a6ff',
  header: 'header_24f5a6ff',
  chevron: 'chevron_24f5a6ff',
  contactItem: 'contactItem_24f5a6ff',
  content: 'content_24f5a6ff',
};

export default styles;
/* tslint:enable */